const { ccclass } = cc._decorator;
import PlayerInfoSettingView from "./player_info_settingview";
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import ModelData from "../../../public/model_data";
import ModuleManager from "../../../../framework/core/module_manager";
import Utility from "../../../../utility/utility";
import GoogleBillingController from "../../../../sdk/googlebilling_controller";
import DialogTips from "../../../public/module/dialog_tips/dialog_tips";
import LanguageManager from "../../../../manager/language_manager";
import PlayerSettingChildBaseView from "./player_setting_childbase_view";
import CommonSettingItem from "./common_setting_item";
import EventManager from "../../../../manager/event_manager";
import AppData from "../../../public/const/app_data";

@ccclass
@moduleInit("PlayerSettingChildBase")
export default class PlayerSettingChildBase<T extends PlayerSettingChildBaseView, U  extends null> extends ModuleBase<T, U>  {

    itemList = []
    lastChooseItem = null
    lastEqitItem = null
    curBuyItem = null //当前解锁的item

    onInit(intentData: any) {
        super.onInit(intentData);
    }



    //切换
    chooseItem(item){
        if (item == null || item.itemData == null){ return }
        //正式环境游戏中不切换牌背
        if (!AppData.testMode){
            if (AppData.inTable && item.itemData.plizedType == "card_icon"){
                ModuleManager.instance.toastKey("player_setting_nochange")
                return 
            }
        }

        let self = this
        if (self.lastChooseItem != null){ 
            self.lastChooseItem.updateChoose(false)
         }
        item.updateChoose(true)
        self.lastChooseItem  = item
        this.view.showLeftInfo(item.itemData)
        let itemData = item.itemData
        if (itemData.isHave){
            if (this.lastEqitItem == item) { return }
            EventManager.instance.dispatch('Event_Update_Local_Plized', itemData)
            item.updateEqit(true)
            if (this.lastEqitItem != null){
                this.lastEqitItem.updateEqit(false)
            }
            this.lastEqitItem = item
        }
    }

    //切换选择
    checkPlized(itemData, callBack){  
        if (itemData == null) { return }
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "plized/checkPlized?",
            params: {
                plizedType: itemData.plizedType,
                plizedCode:itemData.plizedCode,
                gameUserId:ModelData.instance.roleData.id,
            },
        }
        this.apiHttpGet(requestData, function (respone) {
            if (callBack != null){
                callBack(itemData)
            }
        })
    }
    
    //购买商品
    onBuyShopEvent(item){
        if (!item.itemData.isGoods){ return }
        let self = this
        if (!Utility.isNativeIOS() && ModuleManager.instance.isNoAccessShowModule(null, true, () => {
                self._buyItem(item)
            })) {
            return
        }
        self._buyItem(item)
    }

    _buyItem(item) {
        this.curBuyItem = item
        let itemData = item.itemData.goodsVo
        if (itemData.costType == 1){
            if (Utility.isNativeIOS()) {
                ModuleManager.instance.showModuleName("NetPrompt", {showLongTime : true})
            } else {
                ModuleManager.instance.showModuleName("NetPrompt")
            }
            GoogleBillingController.purchaseInApp(itemData.goodsCode)
        }
        else{
            let self = this
            let callBack = function(){
                let requestData: IHttpRequestData = {
                    baseUrl: "order/purchaseInnerOrder?",
                    showNetPrompt: true,
                    params: {
                        goodsCode: itemData.goodsCode,
                        onlinePayType:0,
                    }
                }
                self.apiHttpGet(requestData, function (respone) {
                    //购买是阻塞流程 所以可以保证是当前页签购买的物品
                    self.getSelfCurrencyData()
                    self.getUserPlizedListData(self.curBuyItem.itemData.plizedType)
                    ModuleManager.instance.showModuleName('DialogReceive', [{type:10, num:1, itemCode:item.itemData.plizedCode}])
                })
            }
            ModuleManager.instance.showModule(DialogTips, { Content: LanguageManager.t("pubilc_tips_buy") + itemData.goodsDescription, EnterCallBack:callBack})
        }
    }

    showBuyOver(goodsCode){
        if (this.curBuyItem == null){ return }
        //购买是阻塞流程 所以可以保证是当前页签购买的物品
        if (this.curBuyItem.itemData.goodsVo.goodsCode == goodsCode){
            this.getUserPlizedListData(this.curBuyItem.itemData.plizedType)
            ModuleManager.instance.showModuleName('DialogReceive', [{type:10, num:1, itemCode:this.curBuyItem.itemData.plizedCode}])
        }   

    }

    //通过个性化类型获取数据
    getUserPlizedListData(plizedType){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "plized/getUserPlizedList?",
            params: {
                plizedType: plizedType,
                gameUserId:ModelData.instance.roleData.id,
            },
            showNetPrompt: true,
        }
        this.apiHttpGet(requestData, function (respone) {
           
            if (self.lastChooseItem != null){
                let datalist = []
                for (let index = 0; index < respone.data.length; index++) {
                    const element = respone.data[index];
                    if (element.plizedCode == "empty"){
                        datalist.splice(0, 0, element)
                    }
                    else{
                        datalist.push(element)
                    }
                    
                }
                EventManager.instance.dispatch('Event_Update_PlizedListData', plizedType, datalist) //通知更新数据
                self.lastChooseItem.viewBase.showItem(datalist)
                self.lastChooseItem.onChooseEvent()
            }
        })
    }

}